module.exports = __webpack_public_path__ + "static/section-6-b7168566232eefc451f76164675f3ea2.jpg";